import { type ReactNode, useEffect } from "react";
import { Box, Stack } from "@mui/material";
import {
  BOTTOM_MENU_HEIGHT,
  BottomMenu,
} from "Components/Layout/Menu/BottomMenu";
import { ChatHeaderBar } from "Components/Chat/ChatHeaderBar";
import { ChatTitleRow } from "Components/Chat/ChatTitleRow";
import { useIsMobile } from "Hooks/useIsMobile";
import { Resources, useResource } from "Translations/Resources";

type Props = {
  children: ReactNode;
  isChatDetailView?: boolean;
};

export const ChatLayout = ({ children, isChatDetailView }: Props) => {
  const { t } = useResource();
  const isMobile = useIsMobile();

  useEffect(() => {
    document.title = `${t(Resources.Chat.Title)} | ${t(Resources.Common.AppName)}`;
  }, [t]);

  const isHeaderVisible = !isMobile || (isMobile && !isChatDetailView);
  const paddingBottom =
    isMobile && !isChatDetailView ? BOTTOM_MENU_HEIGHT : undefined;

  return (
    <Box
      display="flex"
      position="relative"
      height="100dvh"
      width="100vw"
      overflow="hidden"
      bgcolor="common.white"
    >
      <Stack flex={1} minWidth={0} pb={paddingBottom}>
        {isHeaderVisible && (
          <>
            <ChatHeaderBar />
            <ChatTitleRow />
          </>
        )}
        <Box flex={1} overflow="hidden">
          {children}
        </Box>
      </Stack>
      {isMobile && !isChatDetailView && <BottomMenu />}
    </Box>
  );
};
